import { render, staticRenderFns } from "./SingleInspirasjon.vue?vue&type=template&id=2ccaff54"
import script from "./SingleInspirasjon.vue?vue&type=script&lang=js"
export * from "./SingleInspirasjon.vue?vue&type=script&lang=js"
import style0 from "./SingleInspirasjon.vue?vue&type=style&index=0&id=2ccaff54&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports